import "babel-polyfill";
import React from "react";
import { render } from "react-dom";
import { Router, browserHistory } from "react-router";
import routes from "./routes";
import configureStore from "./store/configureStore";
import { Provider } from "react-redux";
import Toaster from "toastr";
import { Permissioned } from "react-permissions";
import { loadUserPermissions } from "./actions/permissionsAction";
//import {loadAuthors} from './actions/authorActions';

//Import Styles
import "react-select/dist/react-select.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-table/react-table.css";
import "./styles/index.css";
import "../node_modules/toastr/build/toastr.min.css";
import "../node_modules/react-spinkit/css/loaders-css.css";

const store = configureStore();

// Dispatch actions to load initial state.
store.dispatch(loadUserPermissions());
//store.dispatch(loadAuthors());

//Toaster config
Toaster.options.closeButton = true;
Toaster.options.timeOut = 15000;
Toaster.options.extendedTimeOut = 5000;

//Configure permissioned mapper
Permissioned.mapPermissions = (props) => {
  return props.userPermissions;
};

render(
  <Provider store={store}>
    <Router history={browserHistory} routes={routes} />
  </Provider>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js